<template>
  <article
    v-if="currentPage && currentPage.protection.locked === false"
    class="archive-help single-page"
    id="help-page"
  >
    <PageHeader />
    <ModuleBuilder
      v-if="currentPage.acf && currentPage.acf.modules"
      class="modules"
      :modules="currentPage.acf.modules"
    />
    <FilteredPostsList
      taxonomy="help_cat"
      postType="help"
      filters
      search
      searchPlaceholder="Søk"
      key="help_cat"
    />
  </article>
  <PassProtected
    v-else-if="currentPage && currentPage.protection.locked === true"
  >
  </PassProtected>
</template>

<script>
import FilteredPostsList from "@/components/blocks/FilteredPostsList";

export default {
  name: "archive-help",
  components: {
    FilteredPostsList
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {}
};
</script>
